import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '@/api/client';
import Logo from '@/components/Logo';
import { ShieldCheck, LogIn } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: 'admin@ministryofjesus.ie', password: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If admin token already set, redirect
    const t = localStorage.getItem('moj_admin_token');
    if (t) nav('/admin');
  }, [nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/auth/admin-login', form);
      if (!['admin', 'pastor'].includes(data.profile.role)) throw new Error('Not authorized');
      localStorage.setItem('moj_admin_token', data.token);
      localStorage.setItem('moj_admin_profile', JSON.stringify(data.profile));
      toast.success('Welcome back');
      nav(data.profile.role === 'pastor' ? '/pastor' : '/admin');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Invalid credentials');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-moj-cream flex items-center justify-center px-4 py-16">
      <div className="card-moj p-8 max-w-md w-full">
        <div className="flex justify-center mb-4"><Logo size="lg" showText={false}/></div>
        <h1 className="font-serif text-2xl text-center text-moj-purple-deep mb-1">Admin Portal</h1>
        <p className="text-center text-sm text-moj-charcoal/70 mb-6">For approved church admins. Pastors should sign in at <Link to="/pastor/login" className="text-moj-purple underline">/pastor</Link>.</p>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-login-form">
          <div><label className="label-moj">Email</label><input className="input-moj" type="email" required value={form.email} onChange={(e) => setForm({...form, email: e.target.value})}/></div>
          <div><label className="label-moj">Password</label><input className="input-moj" type="password" required value={form.password} onChange={(e) => setForm({...form, password: e.target.value})}/></div>
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-login-submit"><LogIn size={16}/> {loading ? 'Signing in…' : 'Sign in'}</button>
        </form>
        <div className="flex items-center justify-center gap-1 text-xs text-moj-charcoal/60 mt-4"><ShieldCheck size={12}/> Encrypted login • Audit logged</div>
      </div>
    </div>
  );
}
